<ng-http-loader [debounceDelay]="300" spinner="sk-three-bounce"></ng-http-loader>
<app-header (snackBarEvent)="onSnackBar()"></app-header>
<div class="container">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>